module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cIfNr"))).then(() => parcelRequire('cvs7o'));